import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "“激情丛林”系列及都市悬疑情感剧集",
    count: "40+ 部剧集",
  },
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "冒险、爱情、科幻等类型电影精选",
    count: "30+ 部影片",
  },
  {
    to: "/category/hot",
    icon: "ri-fire-line",
    title: "热门推荐",
    desc: "按播放热度排序的口碑佳作合集",
    count: "实时热度榜",
  },
];

export default function CategoryEntrances() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {ENTRIES.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group flex items-center gap-4 p-5 md:p-6 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 cursor-pointer transition-colors"
            >
              <span className="w-14 h-14 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${entry.icon} text-3xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-lg font-extrabold text-foreground-950">
                    {entry.title}
                  </span>
                  <span className="text-xs font-semibold text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                    {entry.count}
                  </span>
                </span>
                <span className="block mt-1 text-sm text-foreground-500 truncate">{entry.desc}</span>
              </span>
              <i
                className="ri-arrow-right-line text-xl text-foreground-300 group-hover:text-primary-600 group-hover:translate-x-1 transition-all"
                aria-hidden="true"
              ></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}